import React from "reactn";

export const RouteProvider =
	(Provider) =>
	(Component) =>
	({ history, location, match }) => {
		return (
			<Provider history={history} location={location} match={match}>
				{Component}
			</Provider>
		);
	};
